import React, { useEffect, useRef, useState } from "react";
import "./Herosection.css";
import { useCountry } from "../utility/utility";

const stats = [
  { value: "80K+", label: "Users", target: 80, suffix: "K+" },
  { value: "25K+", label: "Businesses", target: 25, suffix: "K+" },
  { value: "91%", label: "Retention", target: 91, suffix: "%" },
  { value: "4.8★", label: "Rating", target: 4.8, suffix: "★", decimal: true },
];

function useCountUp(target, duration = 2000, decimal = false) {
  const [count, setCount] = useState(decimal ? "0.0" : 0);
  const raf = useRef(null);

  useEffect(() => {
    const start = performance.now();
    const step = (now) => {
      const elapsed = now - start;
      const progress = Math.min(elapsed / duration, 1);
      // ease out cubic
      const eased = 1 - Math.pow(1 - progress, 3);
      const current = eased * target;
      setCount(decimal ? current.toFixed(1) : Math.floor(current));
      if (progress < 1) {
        raf.current = requestAnimationFrame(step);
      } else {
        setCount(decimal ? target.toFixed(1) : target);
      }
    };
    raf.current = requestAnimationFrame(step);
    return () => cancelAnimationFrame(raf.current);
  }, [target, duration, decimal]);

  return count;
}

function StatItem({ stat }) {
  const count = useCountUp(stat.target, 2000, stat.decimal);
  return (
    <div className="hero__stat" key={stat.label}>
      <span className="hero__stat-value">
        {count}
        {stat.suffix}
      </span>
      <span className="hero__stat-label">{stat.label}</span>
    </div>
  );
}

export default function Herosection({ onBookDemo }) {
    const { countryCode } = useCountry();
      const phoneNumber = countryCode === "ae" ? "971562198924" : "917835065469";
    
  return (
    <section className="heromain mainclass">
      <div className="hero maxwidth">
        <div className="hero__left">
          <div className="hero__badge">
            <span className="hero__badge-dot" />
            <span className="hero__badge-flag">{countryCode === "ae" ? "🇦🇪" : "🇮🇳"}</span>
            Trusted by 25,000+ Businesses in {countryCode === "ae" ? "UAE" : "India"}
          </div>
          <h1 className="hero__headline">
            <span className="hero__headline--white">World’s First Business AI</span>
            <span className="hero__headline--gradient"> Your All-in-One Business Growth Solution</span>
          </h1>

          <p className="hero__sub">
            Manage marketing, customers, and AI conversations from one powerful platform. Get AI Chatbots, NFC Cards, No-Code Apps, and more tools to grow your business.
          </p>

          <div className="hero__stats">
            {stats.map((s) => (
              <StatItem stat={s} key={s.label} />
            ))}
          </div>

          <div className="hero__ctas">
            <button
              className="hero__btn hero__btn--orange"
              onClick={onBookDemo}
            >
              🚀 Book My Free Demo
            </button>
            <button
              className="hero__btn hero__btn--green"
              onClick={() =>
                window.open(`https://wa.me/${phoneNumber}`, "_blank")
              }
            >
              💬 WhatsApp Us Now
            </button>
          </div>
        </div>

        <div className="hero__right">
          <div className="hero__revenue-card">
            <div className="hero__revenue-card-header">
              <span className="hero__revenue-label">Today's Revenue</span>
              <span className="hero__revenue-badge">↑ 18%</span>
            </div>
            <div className="hero__revenue-amount">{countryCode === "ae" ? "AED" : "₹"} 4,280</div>
            <div className="hero__revenue-sub">34 new leads this week</div>
            <div class="dpill-bar">
              <div class="dpill-fill"></div>
            </div>
          </div>
          <div className="hero__nfc-card">
            <div class="nc-logo">BusinessBay</div>
            <div class="nc-nfc">
              <svg
                class="nc-nfc-icon"
                viewBox="0 0 32 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M16 4C9.373 4 4 9.373 4 16s5.373 12 12 12 12-5.373 12-12S22.627 4 16 4z"
                  stroke="rgba(232,98,26,0.6)"
                  stroke-width="1.5"
                  fill="none"
                ></path>
                <path
                  d="M16 8c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8z"
                  stroke="rgba(232,98,26,0.4)"
                  stroke-width="1.5"
                  fill="none"
                ></path>
                <path
                  d="M16 12c-2.209 0-4 1.791-4 4s1.791 4 4 4 4-1.791 4-4-1.791-4-4-4z"
                  fill="rgba(232,98,26,0.7)"
                ></path>
              </svg>
            </div>
            <div className="hero__nfc-card-name">
              <h4>Ahmed Al Mansoori</h4>
              <p>CEO · Digital Ventures Dubai</p>
            </div>
          </div>

          <div className="hero__lead-card">
            <div className="hero__lead-icon">📍</div>
            <div>
              <div className="hero__lead-title">New Lead — Just Now</div>
              <div className="hero__lead-sub">Via NFC Tap · Dubai Marina</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
